function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPay3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10 7)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,95,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-10, -7)",
    d: "M 12.504 2.26369 L 7.3395 2.28144 L 7.49599 11.7364 L 12.6605 11.7186 L 12.504 2.26369 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -4.82 0.03)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(235,0,27)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-5.18, -7.03)",
    d: "M 7.67941 7.02798 C 7.64745 5.10492 8.50892 3.39621 9.85825 2.28786 C 8.83975 1.48864 7.56289 1.00804 6.17875 1.01278 C 2.89963 1.02401 0.291422 3.72537 0.346722 7.05309 C 0.402022 10.3808 3.09971 13.064 6.37883 13.0528 C 7.76297 13.048 9.02372 12.5587 10.0155 11.7526 C 8.6298 10.6704 7.71137 8.95103 7.67941 7.02798 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.82 -0.03)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,158,27)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-14.82, -6.97)",
    d: "M 19.6533 6.94694 C 19.7086 10.2747 17.1004 12.976 13.8213 12.9873 C 12.4371 12.992 11.1603 12.5114 10.1418 11.7122 C 11.5076 10.6038 12.3526 8.89511 12.3206 6.97206 C 12.2886 5.049 11.3705 3.34639 9.98447 2.24741 C 10.9763 1.4413 12.237 0.952007 13.6212 0.947267 C 16.9003 0.936036 19.5983 3.63595 19.6533 6.94694 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay3);
export default __webpack_public_path__ + "static/media/Pay3.8876e5149ce5e5cf1d3c7d340cff8726.svg";
export { ForwardRef as ReactComponent };